import $ from 'jquery';
import 'select2';

$('select:not(.no-select2)').select2({
    width: '100%',
    minimumResultsForSearch: -1, // disable search box
});
